import { Component } from "@angular/core";

@Component({
    selector:'user-management',
    template:require('./user-management.component.html'),
    styles:[require('./user-management.component.css')]
})
export class UserManagementComponent{}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-management/user-management.component.ts